import { FaFloppyDisk, FaPenToSquare } from 'react-icons/fa6';
import styles from './EditMarket.desktop.module.css';
import { useEditMarketController } from '../EditMarket.controller';

export default function EditMarketDesktopView() {
  const { isInEditMode, startEditMarket, finishEditMarket } = useEditMarketController();

  return (
    <div className={styles.container}>
      {!isInEditMode && <FaPenToSquare onClick={() => startEditMarket()} className={styles.icon} />}

      {isInEditMode && <FaFloppyDisk onClick={() => finishEditMarket()} className={styles.icon} />}
    </div>
  );
}
